import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding-top: 120px; /* Space for header and title */
  padding-bottom: 60px; /* Space for footer */
  position: relative;
`;

export const Title = styled.h1`
  color: #333;
  margin-bottom: 24px;
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 800px;
  padding: 0 20px;
`;

export const ListItem = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
  }

  p {
    margin: 0 0 8px 0;
    color: #555;
    font-size: 14px;
  }

  strong {
    color: #000;
  }
`;

export const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '1000px',
    height: '90vh',
    padding: '0',
    border: 'none',
    borderRadius: '8px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 1000,
  },
};

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid #eee;
    background-color: #f7f7f7;

    h2 {
        margin: 0;
        color: #333;
        font-size: 20px;
    }
`;

export const CloseButton = styled.button`
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #888;
    &:hover {
        color: #333;
    }
`;

export const ModalBody = styled.div`
    display: flex;
    flex: 1;
    overflow: hidden;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const DetailsSection = styled.div`
    width: 40%;
    padding: 24px;
    overflow-y: auto;
    border-right: 1px solid #eee;

    h3 {
        margin-top: 0;
        margin-bottom: 15px;
        color: #cf0505;
        font-size: 16px;
        border-bottom: 1px solid #eee;
        padding-bottom: 8px;
    }

    p {
        margin-bottom: 10px;
        line-height: 1.5;
        font-size: 14px;
    }

    hr {
        margin: 24px 0;
        border: 0;
        border-top: 1px solid #eee;
    }

    @media (max-width: 768px) {
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #eee;
        max-height: 50%;
        padding: 16px;
    }
`;

export const MapSection = styled.div`
    width: 60%;
    height: 100%;
    
    .leaflet-container {
        height: 100%;
        width: 100%;
    }

    @media (max-width: 768px) {
        width: 100%;
        height: 50%;
    }
`;


export const BackButton = styled.button`
    position: absolute;
    top: 80px;
    left: 20px;
    background-color: transparent;
    border: none;
    font-size: 16px;
    color: #cf0505;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 8px;
    border-radius: 4px;
    
    &:hover {
        background-color: #f0f0f0;
    }
`;